import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-row-link-detail',
  standalone: false,
  template: `
    <div class="rl-detail" style="margin-top:12px;padding:12px;border:1px solid #ccc;border-radius:6px;">
      <b>Unit #{{ id }}</b>
      <span *ngIf="stateName"> — из router state: {{ stateName }}</span>
    </div>
    <p><a routerLink="/demo/table-row-link">← Назад к таблице</a></p>`,
})
export class RowLinkDetailComponent implements OnInit {
  id: string | null = null;
  stateName: string | null = null;

  constructor(private route: ActivatedRoute) {}

  ngOnInit(): void {
    this.route.paramMap.subscribe(pm => {
      this.id = pm.get('id');
      this.stateName = (history.state as { name?: string } | null)?.name ?? null;
    });
  }
}
